import nanoScroller from '@global/vendors/jquery.nanoscroller.min';
import Vue from 'vue';
import modal from 'bootstrap/js/dist/modal';
import AlertDialog from '@global/helpers/alertDialog';
import streamCart from '@page/common/js/streamCart';
import messageBox from '@global/helpers/messageBox';
import validate from '@global/vendors/jquery.validate.min';
import Collapse from 'bootstrap/js/dist/collapse';
import store from '@global/components/store/index';
import utmDetect from '@global/helpers/utmDetect';
import cookieMethod from '@global/helpers/cookieMethod';
import NewImage from '@global/components/global/image';
import { createNamespacedHelpers } from 'vuex';
import $ from 'jquery';
import { fireSearchListEvent } from '@global/gtm/shopList/shopListView';
import fireSearchEvent from '@global/gtm/search';
import axios from 'axios';
import Marquee from '../../../template/home/Marquee.pug';

import globalCtrl from './globalCtrl';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('miniCartModule');

global.$ = global.jQuery = require('jquery'); // fix can't use JQ in inline script
require('sticky-kit/dist/sticky-kit');

// 全域方法前後端使用
window.AlertDialog = AlertDialog;
window.messageBox = messageBox;
window.Vue = Vue;
globalCtrl();

if ($('#app-mini-cart').length > 0) {
  window.appNotificationCart = new Vue({
    el: '#app-mini-cart',
    store,
    components: { NewImage },
    computed: {
      ...mapState([
        'totalCount',
        'generalCount',
        'refrigerationCount',
        'freezingCount',
        'dataIsLoad',
        'generalMarketProducts',
        'refrigerationMarketProducts',
        'freezingMarketProducts',
        'count',
        'hotSearch',
        'hotLoad',
      ]),
      ...mapGetters(['isOnlyOneTemp']),
    },
    watch: {
      hotLoad(value) {
        if (value && window.location.pathname.includes('search')) {
          fireSearchListEvent(this.hotSearch);
        }
      },
    },
    created() {
      this.getCartInfo();
      this.getHotSearch();
    },
    methods: {
      ...mapActions(['getCartInfo', 'getHotSearch']),
      customCount(count) {
        if (count < 10) {
          return `0${count.toString()}`;
        }
        return count.toString();
      },
      goSearch(item) {
        window.location.href = `/search?Keyword=${item}`;
        fireSearchEvent({
          isHotSearch: true,
          keyword: item,
        });
      },
      goInputSearch() {
        if ($('#global-search').val().length !== 0) {
          window.location.href = `/search?Keyword=${$('#global-search').val()}`;
          fireSearchEvent({
            isHotSearch: false,
            keyword: $('#global-search').val(),
          });
        }
      },
    },
  });
}

const marquee = new Vue({
  el: '#header-marquee',
  data() {
    return {
      marquee: {},
      isShowMarquee: false,
    };
  },
  async created() {
    this.isShowMarquee = false;
    const versionNumber = this.generateVersionNumber();

    let loadJson = '';

    if (window.PictureContainer.indexOf('-t') !== -1) {
      loadJson = `https://static.tpx.tw/sff-t/pazzo-v2-dev/json/marquee.json?v=${versionNumber}`;
    } else {
      loadJson = `https://static.tpx.tw/sff/pazzo-v2/json/marquee.json?v=${versionNumber}`;
    }

    // const loadJson = './api/json/marquee.json';

    let marqueeArray = [];
    const now = Date.now();

    try {
      const res = await axios.get(loadJson);
      marqueeArray = res.data.Response;

      marqueeArray.forEach((element) => {
        const startTime = new Date(element.startTime).getTime();
        const endTime = new Date(element.endTime).getTime();
        if (now >= startTime && now <= endTime) {
          this.marquee = element;
          this.isShowMarquee = true;
        }
      });

      Object.entries(this.marquee.themeColors).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--${key}`, value);
      });
    } catch (err) {
      this.isShowMarquee = false;
    }
  },
  methods: {
    generateVersionNumber() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const date = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');

      return `${year}${month}${date}${hour}`;
    },
  },
  template: Marquee,
});

// 電子報
const mailValidate = {
  errorClass: 'error',
  errorElement: 'div',
  rules: {
    newsletter: {
      required: true,
      email: true,
    },
  },
  messages: {},
  errorPlacement(error, element) {
    element.parent().append(error);
  },
  submitHandler(form) {
    const $input = $(form).find('.input-newsletter');

    axios
      .post(API_URL.SUBSCRIBE, {
        Email: $input.val(),
      })
      .then((res) => {
        if (res.data.Code === 200) {
          AlertDialog.alert(res.data.Message);
        } else if (res.data.Code === 400) {
          AlertDialog.alert(res.data.Message);
        }
      })
      .catch((error) => {
        AlertDialog.alert(error);
      });
  },
};
$('#form-newsletter-signup').validate(mailValidate);

if ($('.btn-live-cart').length !== 0) streamCart();

// KOL UTM SETTING
function KolUtmSetting() {
  let cookieName = 'kol_utm';
  let kolUtmStr = utmDetect();
  // if (kolUtmStr!==null)
  if (kolUtmStr !== null) {
    cookieMethod.setCookie(cookieName, kolUtmStr, 1);
  }
}

KolUtmSetting();

$('.secnav-right__search').click(function (e) {
  e.preventDefault();
  $('.search-form').addClass('open');
  $('.secnav-right__cancel').css('display', 'block');
  $('.secnav-right__search').css('display', 'none');
  $('.secnav-right__mypazzo').css('display', 'none');
  $('.secnav-right__bag').css('display', 'none');
  $('.secnav-right__burger').css('display', 'none');
  $('#global-search').get(0).focus();
});

$('.secnav-right__burger').click(function (e) {
  e.preventDefault();
  $('.sidebar').addClass('active');
  $('.secnav-right__cancel').css('display', 'block');
  $('.secnav-right__search').css('display', 'none');
  $('.secnav-right__mypazzo').css('display', 'none');
  $('.secnav-right__bag').css('display', 'none');
  $('.secnav-right__burger').css('display', 'none');
});

$('.secnav-right__cancel').click(function (e) {
  e.preventDefault();
  $('.sidebar').removeClass('active');
  $('.search-form').removeClass('open');
  $('.secnav-right__cancel').css('display', 'none');
  $('.secnav-right__search').css('display', 'block');
  $('.secnav-right__mypazzo').css('display', 'block');
  $('.secnav-right__bag').css('display', 'block');
  $('.secnav-right__burger').css('display', 'block');
});
